import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetIncidentDetailsAsync, IIncidentDetails } from "../../api/IIncident";
import { RootState } from "../store";

export interface IncidentState {
  fetchStatus: string;
  incident?: IIncidentDetails;
}

const initialState: IncidentState = {
  fetchStatus: "Loading...",
  incident: undefined,
};

export const loadIncidentAsync = createAsyncThunk(
  "incident/load",
  async (incidentId: string) => {
    const response = await GetIncidentDetailsAsync(incidentId);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const incidentSlice = createSlice({
  name: "incident",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadIncidentAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadIncidentAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.incident = action.payload;
      });
  },
});

export const selectIncident = (state: RootState) => state.incident;

export default incidentSlice.reducer;
